import Swal from "sweetalert2";

const CustomAlert = ({
  title,
  text,
  html,
  icon,
  confirmButtonText,
  showCancelButton,
  cancelButtonText,
  allowOutsideClick,
  cancelButtonColor,
}) => {
  return Swal.fire({
    title: title,
    text: text,
    html: html,
    icon: icon,
    confirmButtonText: confirmButtonText || "OK",
    showCancelButton: showCancelButton || false,
    cancelButtonText: cancelButtonText || "Cancel",
    allowOutsideClick: allowOutsideClick || false,
    cancelButtonColor: cancelButtonColor || "#aaa",

    didOpen: () => {
      const iconEl = Swal.getIcon();
      if (iconEl) {
        iconEl.style.borderColor = "#ff702b";
        const contentEl = iconEl.querySelector(".swal2-icon-content");
        if (contentEl) contentEl.style.color = "#ff702b";
      }
    },
  });
};

export default CustomAlert;
